import { FC } from 'react';
import Box from '@mui/material/Box';
import { getDateTime } from '../lib/utils';
import { DataType } from '../model/types';
import { CertificateCard, CertificateInfo, CertificateText } from './styled';

const Archive: FC<{ data?: DataType[] }> = ({ data }) => (
    <Box display='flex' flexDirection='column' gap={1}>
        {data
            ?.sort((a, b) => {
                if (a.receivingDate > b.receivingDate) {
                    return 1;
                }
                if (a.receivingDate < b.receivingDate) {
                    return -1;
                }

                return 0;
            })
            .map(
                ({
                    id,
                    certificateKind,
                    recipientFullName,
                    status,
                    snils,
                    receivingDate,
                    resolverFullName,
                    declarant,
                    declarantType,
                    recipientBirthDate,
                    polis,
                    sanatoriumName,
                }) => {
                    const {
                        lastName,
                        firstName,
                        middleName,
                        snils: declarantSnils,
                        documentPersonal: { nameDoc, serie, number, issuer, issueDate, codePodr },
                    } = declarant;

                    const declarantNameWithSnils =
                        lastName + ' ' + firstName + ' ' + middleName + ', снилс: ' + declarantSnils;

                    const declarantDocument =
                        nameDoc +
                        ': ' +
                        serie +
                        ' ' +
                        number +
                        ', выдан: ' +
                        issuer +
                        ' ' +
                        getDateTime(new Date(issueDate), true) +
                        ', код подразделения: ' +
                        codePodr;

                    return (
                        <CertificateCard
                            key={id}
                            sx={{
                                backgroundColor: 'rgba(30, 41, 59, 0.2)',
                                borderColor: 'rgba(59, 130, 246, 0.2)',
                                opacity: 0.8,
                                '&:hover': {
                                    backgroundColor: 'rgba(30, 41, 59, 0.3)',
                                    opacity: 1,
                                },
                            }}
                        >
                            <CertificateInfo>
                                <CertificateText
                                    variant='h6'
                                    sx={{ color: 'rgba(147, 197, 253, 0.7)', fontWeight: 600 }}
                                >
                                    {recipientFullName}
                                </CertificateText>
                                {recipientBirthDate && (
                                    <CertificateText>
                                        <strong>Дата рождения:</strong>{' '}
                                        {getDateTime(new Date(recipientBirthDate), true)}
                                    </CertificateText>
                                )}
                                <CertificateText>
                                    <strong>СНИЛС:</strong> {snils}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Полис:</strong> {polis || '-'}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Санаторий:</strong> {sanatoriumName || '-'}
                                </CertificateText>
                                <CertificateText sx={{ color: 'rgba(6, 182, 212, 0.6)', fontWeight: 500 }}>
                                    {certificateKind.name}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Дата подачи:</strong> {getDateTime(new Date(receivingDate))}
                                </CertificateText>

                                <CertificateText>
                                    <strong>Заявитель:</strong> {declarantType.name}
                                </CertificateText>
                                <CertificateText>{declarantNameWithSnils}</CertificateText>
                                <CertificateText>{declarantDocument}</CertificateText>
                                <CertificateText>
                                    <strong>Обработал:</strong> {resolverFullName}
                                </CertificateText>
                                <CertificateText>
                                    <strong>Статус:</strong> {status.name}
                                </CertificateText>
                            </CertificateInfo>
                        </CertificateCard>
                    );
                },
            )}
    </Box>
);

export default Archive;
